import { Component, OnInit, inject } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { GlobalMessageService, GlobalMessageType, LoggerService, tryNormalizeHttpError, TranslatePipe } from '@spartacus/core';
import { Subscription } from 'rxjs';
import { SloanCpqConfiguratorService } from '../../../common/services/sloan-cpq-configurator.service';
import { Entry2 } from '../../../models/configurator.model';
import { environment } from '../../../../environments/environment';

@Component({
    selector: 'app-sloan-cpq-aprove-design',
    templateUrl: './sloan-cpq-aprove-design.component.html',
    styleUrls: ['./sloan-cpq-aprove-design.component.scss'],
    imports: [TranslatePipe]
})
export class SloanCpqAproveDesignComponent implements OnInit {
  protected logger = inject(LoggerService);
  configurator: Entry2;
  subscription = new Subscription();
  selectedConfigurators: string[];
  entries: Entry2[];
  selectedEntries: Entry2[] = [];
  projectId: string;
  showErrorMessage = false;
  fromDownloadReq = false;
  showDesignDocumentMap: Map<string, boolean> = new Map<string, boolean>();
  phoneNumber = environment.globalHelpphoneNumber;
  email = environment.globalHelpemail;
  workingDays = environment.globalHelpworkingDays;
  workingHours = environment.globalHelpworkingHours;
  constructor(
    private ngbActiveModal: NgbActiveModal,
    private sloanCpqConfiguratorService: SloanCpqConfiguratorService,
    private globalMessageService: GlobalMessageService
  ) {}

  ngOnInit(): void {
    // When opened from the Download & Request Documents dialog, selectedEntries
    // and showDesignDocumentMap are passed directly — no need to call the service again.
    if (this.fromDownloadReq) {
      return;
    }
    this.subscription.add(
      this.sloanCpqConfiguratorService.loadSelectedConfigurators$().subscribe((selectedProductsCodes) => {
        this.selectedConfigurators = selectedProductsCodes;
        this.sloanCpqConfiguratorService.loadConfigurators().subscribe((res) => {
          if (res) {
            if (this.selectedConfigurators && this.selectedConfigurators.length > 0) {
              this.selectedEntries = res?.savedCartData?.entries?.filter((entry) => {
                return entry && this.selectedConfigurators.includes(entry?.configurationUid as unknown as string);
              }) || [];
            } else if (this.configurator) {
              this.selectedEntries = [this.configurator];
            } else {
              this.selectedEntries = [];
            }
          }
        });
      })
    );
  }

  get unavailableDesignEntries(): Entry2[] {
    if (!this.selectedEntries || !this.showDesignDocumentMap) {
      return [];
    }
    return this.selectedEntries.filter(
      (entry) => entry && this.showDesignDocumentMap.get(entry?.configurationUid as unknown as string) === false
    );
  }

  approveDesign() {
    if (!this.fromDownloadReq) {
      const reqObject = {
        configIds: '',
      };
      if (this.selectedConfigurators && this.selectedConfigurators.length > 0) {
        reqObject.configIds = this.selectedConfigurators.join(',');
      } else {
        reqObject.configIds = this.configurator.configurationUid;
      }
      this.sloanCpqConfiguratorService.approveDesign(reqObject, this.projectId).subscribe(
        (res) => {
          this.sloanCpqConfiguratorService.getConfigurators(this.projectId);
          this.closeModal();
          this.globalMessageService.add(
            { key: 'configurators.approveDesign.approvedDesignSuccessFully' },
            GlobalMessageType.MSG_TYPE_CONFIRMATION
          );
        },
        (error) => {
          // console.log(err);
          const errordetail = tryNormalizeHttpError(error, this.logger);
          if (errordetail && 'details' in errordetail && errordetail.details) {
            this.globalMessageService.add({ raw: errordetail.details[0].message }, GlobalMessageType.MSG_TYPE_ERROR);
          } else {
            this.globalMessageService.add({ key: 'configurators.approveDesign.errorMsg' }, GlobalMessageType.MSG_TYPE_ERROR);
          }
          this.closeModal();
        }
      );
    } else {
      this.ngbActiveModal.close(true);
    }
  }

  removeAlert() {
    setTimeout(() => {
      this.showErrorMessage = false;
    }, 3000);
  }

  closeModal() {
    this.ngbActiveModal.dismiss();
  }
}
